import * as React from 'react';
export const BASvg = React.forwardRef(function BASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#43458B',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M2 0h12v12z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M2 1.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1 1a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M12 11.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM1 .5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z',
        opacity: 0.5,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M13 12v-1h1v1h-1ZM2 0h12v1H2V0Z',
      }),
    ),
  );
});
BASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BA = {
  category: 'flag',
  colorable: false,
  name: 'BA',
  svg: BASvg,
};
